export const SCHOOL_SITE_ORDER_FETCHING = 'SCHOOL_SITE_ORDER_FETCHING';
export const SCHOOL_SITE_ORDER_SET_ERROR = 'SCHOOL_SITE_ORDER_SET_ERROR';
export const SCHOOL_SITE_ORDER_SET_SAVE_MESSAGE =
  'SCHOOL_SITE_ORDER_SET_SAVE_MESSAGE';



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/state/types.js